import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .search': {
        height: '41px',
        color: '#58727C',
        backgroundColor: '#fff',
        borderRadius: 4,
        border: '1px solid #ced4da',
        '& .search-icon': {
            padding: '0 10px',
        },
    },
    '& .bgW': {
        backgroundColor: '#fff',
    },
    '& .tableTool': {
        marginBottom: '20px',
    },
    '& .tableWapper': {
        width: '100%',
        // height: '600px',
        overflowX: 'auto',
        '& .table': {
            minWidth: '650px',
        }
    },
    '& .del': {
        color: '#9B9B9B',
        cursor: 'pointer',
    },
    '& .btn': {
        width: '186px',
    },
});